import axios from "axios";
import Post from "../Post";
import getToken from "../token";

export default function editCurrentChildPicture(id, image) {
  const headers = {
    Accept: "application/json",
    "Content-Type": "multipart/form-data",
    "Access-Control-Allow-Origin": "*",
    origin: "https://manager.asqtest.ir",
  };
  const data = new FormData();
  data.append("token", getToken());
  data.append("id", id);
  data.append("image", image);

  return axios.post("https://api.asqtest.ir/user/updateChildPicUrl", data, {
    headers: headers,
  });
}
